/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import Modal from 'app/components/common/Modal.jsx';
import CurateTabs from 'app/components/Curate/CurateTabs.jsx';
import CurationInputListItems from 'app/components/RouteList/CurationInputListItems.jsx';
import ListActionButton from 'app/components/common/ListActionButton.jsx';
import UserMessages from 'app/modules/UserMessageModule.js';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class CurateFeedsList extends React.Component {
    constructor(props) {
        super(props);

        this.onNewFeed = this.onNewFeed.bind(this);

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.app.loading.INPUT_REFRESH === true && this.props.app.loading.INPUT_REFRESH === false) {
			this.props.addMessage(UserMessages.generateMessage(UserMessages.route.created, 'INPUT_REFRESH'));
		}

        if (prevProps.app.loading.CURATION_INPUT_DELETE === true && this.props.app.loading.CURATION_INPUT_DELETE === false) {
            this.props.getUserPerms();
        }

    }

    onNewFeed(e) {

        e.preventDefault();

        if (this.props.user.perms.resources.inputsAvailable === 0) {
            this.props.showUpgradeModal(this.props.closeAllModals, 'inputs', null, 'curate_footer');
        } else {
            this.props.router.navigate('/share/curate/feeds/new');
        }

    }

    render() {

        let Tabs = (
                <CurateTabs
                    {...this.props}
                    active='curate-feeds-list'
                    recordPath={this.props.recordPath}/>
            ),
            Main = (
                <div>
                    <CurationInputListItems
                        {...this.props}
                        route={this.props.curation.route}
                        socials={this.props.socials}
                        recordPath={this.props.recordPath}/>
                    <ListActionButton
                        action={this.onNewFeed}
                        buttonLabel={"Add New Feed"}/>
                </div>
            );

        return (
            <Content
                {...this.props}
                header={Tabs}
                main={Main} />
        );

    }
};

CurateFeedsList.displayName = "CurateFeedsList";

CurateFeedsList.propTypes = {
    recordPath: PropTypes.func,
};

CurateFeedsList.defaultProps = {
    recordPath: null
};


export default ComponentWithContext(CurateFeedsList);
